import React from 'react';
import PropTypes from 'prop-types';

const SimpleBox = ({ children, className }) => {
  const classes = `simple-box center-block ${className}`;
  return (
    <div className={classes}>
      {children}
    </div>
  );
};

SimpleBox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

SimpleBox.defaultProps = {
  className: ''
};


export default SimpleBox;



// WEBPACK FOOTER //
// ./src/components/SimpleBox/index.jsx